import { render, staticRenderFns } from "./AddAppVersion.vue?vue&type=template&id=6c5ef186&"
import script from "./AddAppVersion.vue?vue&type=script&lang=js&"
export * from "./AddAppVersion.vue?vue&type=script&lang=js&"
import style0 from "./AddAppVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports